import { SVGProps } from 'react';

export const TopicsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='22'
    height='22'
    viewBox='0 0 26 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M12.5264 21.2605H8.64908C7.48043 21.2605 6.53442 20.3627 6.53442 19.2585V5.66256C6.53442 4.7936 7.27808 4.08789 8.19373 4.08789H16.4953C17.4109 4.08789 18.1546 4.79365 18.1546 5.66256L18.1546 8.18945'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M15.6607 3.38294V4.08612H9.02856V3.38294C9.02856 2.46729 9.77222 1.72363 10.6879 1.72363H14.0014C14.917 1.72363 15.6607 2.46729 15.6607 3.38294Z'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M10.5 6.99902V7.99902'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M12.6606 7.00879V8.00879'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M14.8425 7.01855V8.01855'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M10.5 10.6787V11.6787'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M12.6606 10.6885V11.6885'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M10.5 14.5107V15.5107'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M12.6606 14.5205V15.5205'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M18.6033 15.5171C20.0316 15.5171 21.1895 14.3592 21.1895 12.9309C21.1895 11.5026 20.0316 10.3447 18.6033 10.3447C17.175 10.3447 16.0171 11.5026 16.0171 12.9309C16.0171 14.3592 17.175 15.5171 18.6033 15.5171Z'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M23.112 21.259C23.112 19.3012 21.1644 17.7178 18.7665 17.7178C16.3686 17.7178 14.4209 19.3012 14.4209 21.259'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);
